export default __webpack_public_path__ + "static/media/Router.7c6f48ee.png";